import { render, staticRenderFns } from "./ArchiveOrder.vue?vue&type=template&id=59e3ddc6"
import script from "./ArchiveOrder.vue?vue&type=script&lang=js"
export * from "./ArchiveOrder.vue?vue&type=script&lang=js"
import style0 from "./ArchiveOrder.vue?vue&type=style&index=0&id=59e3ddc6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports